import Vue from 'vue';
import App from './App';
import router from './router';
import Vuex from 'vuex';
import store from "./store/index";
import VeeValidate from 'vee-validate';
import Toasted from 'vue-toasted';

import './toasts';

Vue.use(Vuex);
Vue.use(VeeValidate);
Vue.use(Toasted);
Vue.config.productionTip = false;

// Dynamic meta tag updates
router.beforeEach((to, from, next) => {
  const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.title);
  if (nearestWithMeta) {
    document.title = nearestWithMeta.meta.title;

    const descriptionTag = document.querySelector('meta[name="description"]');
    if (descriptionTag) {
      descriptionTag.setAttribute('content', nearestWithMeta.meta.description || '');
    } else {
      const tag = document.createElement('meta');
      tag.setAttribute('name', 'description');
      tag.setAttribute('content', nearestWithMeta.meta.description || '');
      document.head.appendChild(tag);
    }
  }
  next();
});

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js